import apiClient from './apiClient';

export interface QuickStats {
  today_consultations: number;
  pending_authorizations: number;
  today_appointments: number;
  total_patients: number;
}

export interface ConsultationStats {
  period: { date_from: string; date_to: string };
  consultations: {
    total: number;
    today: number;
    require_admission: number;
    by_doctor: Array<{
      doctor_id: number;
      total: number;
      doctor: { id: number; first_name: string; last_name: string } | null;
    }>;
  };
  appointments: {
    total: number;
    completed: number;
    pending: number;
  };
  pre_authorizations: { pending: number };
  patients: { active: number };
}

export interface DoctorStats {
  today_appointments: number;
  today_consultations: number;
  total_patients: number;
  recent_consultations: Array<{
    id: number;
    consultation_date: string;
    chief_complaint: string;
    patient: { id: number; first_name: string; last_name: string } | null;
  }>;
}

export const dashboardService = {
  async getQuickStats(): Promise<QuickStats> {
    const response = await apiClient.get<any>('/dashboard/quick-stats');
    return response.data.data || response.data;
  },

  async getConsultationStats(dateFrom?: string, dateTo?: string): Promise<ConsultationStats> {
    const params: Record<string, string> = {};
    if (dateFrom) params.date_from = dateFrom;
    if (dateTo) params.date_to = dateTo;
    const response = await apiClient.get<any>('/dashboard/consultations', { params });
    return response.data.data || response.data;
  },

  async getDoctorStats(doctorId: number): Promise<DoctorStats> {
    const response = await apiClient.get<any>('/dashboard/doctor-stats', { params: { doctor_id: doctorId } });
    return response.data.data || response.data;
  },
};
